// extracted by mini-css-extract-plugin
export var active = "_d5-2";
export var recordingDot = "_d5-1";
export var recordingIndicator = "_d5-0";